import React, { useState, useEffect } from "react";
import "./transferrequest.css";
// components imports
import TransferNotesTable from "../../../../Components/BoltTable/BoltTable";
import TransferRequestDetails from "./Components/TransferRequestDetails/TransferRequestDetails";
import Tooltip from "../../../../Components/Tooltip/Tooltip";
import StatusIcons from "../../../../Components/StatusIcons/StatusIcons";
// apis imports
import { getAllTransferNotesRequest } from "../../../../services/WarehouseServices/warehouse.services";
// library imports
import { useSelector } from "react-redux";
import { MdRemoveRedEye } from "react-icons/md";
import { convertTime } from "../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const TransferRequest = ({ snack, setSnack }) => {
  const { t } = useTranslation(["warehouse", "common"]);
  const user = useSelector((state) => state.user);

  const [open, setOpen] = useState(false);

  const [transferNotes, setTransferNotes] = useState([]);

  const columns = [
    {
      id: 1,
      label: t("transferRequests.reference"),
      render: (row) => <>{row?.reference_no ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("transferRequests.fromWarehouse"),
      render: (row) => <>{row?.from_warehouse?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("transferRequests.toWarehouse"),
      field_name: "to_warehouse",
      render: (row) => <>{row?.to_warehouse?.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("transferRequests.createdBy"),
      render: (row) => <>{user?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("transferRequests.status"),
      render: (row) => (
        <>
          <StatusIcons status={row?.status} />
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("transferRequests.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("transferRequests.actions"),
      render: (row) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("transferRequests.viewTransferDetails")}>
              <div className="table_action__btn" onClick={() => setOpen(row)}>
                <MdRemoveRedEye size={10} />
                {t("transferRequests.details")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "200px",
    },
  ];

  const fetchAllTransferNotesRequest = async (page, perPage, filter) => {
    const response = await getAllTransferNotesRequest(page, perPage, filter);

    if (!response.error) {
      setTransferNotes(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  return (
    <>
      <div className="">
        <>
          <div>
            <TransferNotesTable
              tableTitle={t("transferRequests.transferRequests")}
              tableId="transferNoteTableforWarehouse"
              message={t("transferRequests.noTransferRequestAvailableToDisplay")}
              searchPlaceHolder={t("transferRequests.searchTransferRequest")}
              columns={columns}
              data={transferNotes}
              getAllData={fetchAllTransferNotesRequest}
            />
          </div>
        </>
      </div>
      <TransferRequestDetails
        open={open}
        setOpen={setOpen}
        setSnack={setSnack}
        setTransferNotes={setTransferNotes}
      />
    </>
  );
};

export default TransferRequest;
